import React from "react";
import { useForm } from "react-hook-form";
import { Button, CheckboxController, Grid } from "@pushpress/shared-components";
import LocationController from "../../../components/controllers/LocationSelect";
import StaffSelect from "../../../components/controllers/StaffSelect";
import { ICalendarFilter } from "../Calendar.types";

interface CalendarFilterProps {
  filter?: ICalendarFilter;
  onFilterChange?: (filter: ICalendarFilter) => void;
}

function CalendarFilter(props: CalendarFilterProps) {
  const { filter, onFilterChange } = props;

  const { control, handleSubmit } = useForm<ICalendarFilter>({
    defaultValues: filter,
  });

  const handleClear = () => {
    onFilterChange({
      staff: [],
      locations: [],
    });
  };

  const handelApply = (values: ICalendarFilter) => {
    onFilterChange(values);
  };

  return (
    <form
      style={{ width: 300 }}
      className="p-4"
      onSubmit={handleSubmit(handelApply)}
    >
      <CheckboxController
        control={control}
        name="classes"
        label="Classes"
        className="mb-3"
      />
      <CheckboxController
        control={control}
        name="appointments"
        label="Appointments"
        className="mb-3"
      />
      <CheckboxController
        control={control}
        name="events"
        label="Events"
        className="mb-3"
      />
      <LocationController
        control={control}
        name="locations"
        label="Locations"
        className="mt-4"
        placeholder="— Select —"
        isMulti
        hideDropdownIndicator
        isClearable
        closeMenuOnSelect={false}
        hideSelectedOptions={false}
      />
      <StaffSelect
        control={control}
        name="staff"
        label="Staff"
        placeholder="— Select —"
        isMulti
        hideDropdownIndicator
        isClearable
        closeMenuOnSelect={false}
        hideSelectedOptions={false}
      />
      <Grid container justifyContent="flex-end">
        <Grid item>
          <Button
            text="Clear"
            buttonType="secondary"
            type="button"
            onClick={handleClear}
          />
        </Grid>
        <Grid item>
          <Button text="Apply" buttonType="primary" type="submit" />
        </Grid>
      </Grid>
    </form>
  );
}

export default CalendarFilter;
